module.exports = {
	"root": "findify-components-search--mobile-actions",
	"bottom-row": "findify-components-search--mobile-actions__bottom-row",
	"bottomRow": "findify-components-search--mobile-actions__bottom-row",
	"icon": "findify-components-search--mobile-actions__icon",
	"button": "findify-components-search--mobile-actions__button",
	"facet-count": "findify-components-search--mobile-actions__facet-count",
	"facetCount": "findify-components-search--mobile-actions__facet-count",
	"divider": "findify-components-search--mobile-actions__divider",
	"query": "findify-components-search--mobile-actions__query"
};